import type * as Actions from '@src/redux/actions/filter.alerts.actions'
import * as ActionTypes from '@src/redux/actionTypes'

export interface ViewItem {
  label?: string
  value?: string
}

type Views = {
  [key in 'oneDay' | 'oneWeek' | 'oneMonth' | 'all']: ViewItem
}

export const ViewsByTime: Views = {
  all: { label: 'All', value: 'all' },
  oneDay: { label: 'Last one day', value: '1d' },
  oneWeek: { label: 'Last one week', value: '1w' },
  oneMonth: { label: 'Last one month', value: '1m' }
}

export const defaultState = {
  viewByTime: ViewsByTime.all as ViewItem
}

export type FilterAlertsState = typeof defaultState

export function reducer(
  state = defaultState,
  action: Actions.ActionTypes
): FilterAlertsState {
  switch (action.type) {
    case ActionTypes.Alerts.Filter.CHANGE_VIEW_BY_TIME: {
      return {
        ...state,
        viewByTime: action.payload.selectedView
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
